import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { setCurrentPaymentMethod } from './currentPaymentMethod';
import { OrderingConstants } from 'polygon-ordering';

const { PAYMENT_METHOD } = OrderingConstants;

const initialState = null as string | null;

const slice = createSlice({
  name: 'currentSavedCardToken',
  initialState,
  reducers: {
    setCurrentSavedCardToken(state, action: PayloadAction<string | null>) {
      return action.payload || initialState;
    },
  },
  extraReducers: builder => {
    builder.addCase(
      setCurrentPaymentMethod,
      (state, action: PayloadAction<PAYMENT_METHOD | null>) => {
        if (action.payload !== PAYMENT_METHOD.SAVED_CARD) {
          return initialState;
        }

        return state;
      },
    );
  },
});

export const { setCurrentSavedCardToken } = slice.actions;

export default slice.reducer;
